import React from 'react';
import { CircleContact } from './styles';

interface BiddingViewedContactListProps {
  contactList: Array<string>;
}

const BiddingViewedContactList = (props: BiddingViewedContactListProps) => {
  const { contactList } = props;
  const colors = ['#007BFF', '#53B6B9', '#DC3545', '#28A745', '#ffdf8f', '#5a6268'];

  return (
    <div className="mr-1 d-print-none d-flex align-items-center">
      <span className="text-white mr-1">Visualizado por</span>
      {contactList?.map((contact, key) => {
        const initials = contact
          .split(' ')
          .map((word) => word[0])
          .join('')
          .toUpperCase();
        return (
          <div
            className="viewed-contacts"
            key={contact}
            style={{ display: 'inline-block', margin: '' }}
          >
            <CircleContact
              className="position-relative databalloon"
              color={colors[key]}
              aria-label={contact}
              data-balloon-pos="up"
            >
              {initials}
            </CircleContact>
          </div>
        );
      })}
    </div>
  );
};

export default BiddingViewedContactList;
